module.exports = __webpack_public_path__ + "static/img/step4_2tc@2x.a8dfc98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/howtobuy/step4_2tc@2x.jpg
// module id = 544
// module chunks = 0